import script from "./PhoneSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneSelect.vue?vue&type=script&setup=true&lang=js"

import "./PhoneSelect.vue?vue&type=style&index=0&id=5e46f7dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e46f7dc"]])

export default __exports__